import { useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderedDogsUnits } from '@store/partners-order/selectors';
import { updateOrderedDogsUnitsItem } from '@store/partners-order/slice';
import SizeItem from '@pages/partners-order/sizes-units/SizeItem';



const DogsSizesGrid = (): JSX.Element => {
	
	const orderedDogsUnits = useSelector(selectOrderedDogsUnits);
	const dispatch = useDispatch();
	const updateDogUnitsItem = (label: string, value: number) => dispatch(updateOrderedDogsUnitsItem({ label, value }));


	const sizesArray = useMemo((): Array<{ label: string, value: number }> => {
		return [
			{ label: 'S', value: orderedDogsUnits.sizeS },
			{ label: 'M', value: orderedDogsUnits.sizeM },
			{ label: 'L1', value: orderedDogsUnits.sizeL1 },
			{ label: 'L2', value: orderedDogsUnits.sizeL2 },
			{ label: 'XL1', value: orderedDogsUnits.sizeXL1 },
			{ label: 'XL2', value: orderedDogsUnits.sizeXL2 },
			{ label: 'XXL1', value: orderedDogsUnits.sizeXXL1 },
			{ label: 'XXL2', value: orderedDogsUnits.sizeXXL2 },
			{ label: '3XL1', value: orderedDogsUnits.size3XL1 },
			{ label: '3XL2', value: orderedDogsUnits.size3XL2 },
			{ label: '4XL1', value: orderedDogsUnits.size4XL1 },
			{ label: '4XL2', value: orderedDogsUnits.size4XL2 },
			{ label: '5XL', value: orderedDogsUnits.size5XL },

			{ label: 'XLMini', value: orderedDogsUnits.sizeXLMini },
			{ label: '4XLMini', value: orderedDogsUnits.size4XLMini },
			{ label: '3XLMini', value: orderedDogsUnits.size3XLMini },
			{ label: '2XLMini', value: orderedDogsUnits.size2XLMini },
		];
	},[ orderedDogsUnits ]);

	
	return (
		<div className='dogs-sizes-grid'>
			{sizesArray.map(x =>
				<SizeItem
					label={x.label}
					count={x.value}
					onClick={updateDogUnitsItem}
					key={`size-item-dog-${x.label}`} />)}
		</div>
	);
};

export default memo(DogsSizesGrid);